import React from "react";
import { ModeProvider } from "./context/ModeContext"; // Import the provider
import { HighlightKeyProvider } from "./context/HighlightKeyContext";

// Importing CSS (if needed globally)
import "./css/output.css"; // Tailwind styles
import "./css/global.css"; // Any global custom styles
import "./css/styles.css"; // Import global CSS (optional)

// Importing React components
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
import Skills from "./components/Skills";

function App() {
  return (
    <div className="App">
      <ModeProvider>
        <HighlightKeyProvider>
          <Navbar />
          <Hero />
          <Experience />
          <Skills />
          <Projects />
          <Footer />
        </HighlightKeyProvider>
      </ModeProvider>
    </div>
  );
}

export default App;
